import {Organization} from './organization.types';
import {PRIMARY_COVER_IMAGE_SOURCE} from '@aviary/store/common/common.types';

export const FALLBACK_ORGANIZATION: Organization = {
  copyOverrides: {},
  id: 0,
  googleStaffTenantId: '',
  googlePatronTenantId: '',
  name: '',
  slug: '',
  websiteUrl: '',
  navigationLinks: [],
  staffUrl: '',
  opacUrl: '',
  iconUrl: '',
  bannerUrl: '',
  manualAddressVerificationUrl: '',
  policyUrl: '',
  invitationEmail: '',
  contactEmail: '',
  arcgisBoundaryUrl: '',
  phoneNumber: '',
  hooplaLibraryId: 0,

  coverImageSource: PRIMARY_COVER_IMAGE_SOURCE,
  active: false,
  created: '',
  modified: '',
  usesMEL: false,

  novelistProfile: '',
  novelistPassword: '',

  demoOrganization: false,
  demoStaffUsername: '',
  demoStaffPassword: '',
  demoOpacUsername: '',
  demoOpacPassword: '',
}
